<template>
<div>

    <Nuevo  v-if="NuevoActivo" :NuevoActivo="NuevoActivo" :Accion="Accion" :Item="Item" @NuevoActivo="NuevoActivo = $event"/>

  <v-data-table
    :headers="headers"
    :items="arreglo"
    :items-per-page="5"
    :search="busqueda"
    dense
    sort-by="id"
    sort-desc="true"
    class="elevation-12 mt-5"
    :loading="TablaVacia"
    loading-text="Cargando... Espere por favor"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
      
      <v-toolbar-title>{{titulo}}</v-toolbar-title>
    
        <v-spacer></v-spacer>
        <!--busqueda-->
        <v-text-field
            v-model="busqueda"
            append-icon="mdi-magnify"
            label="BUSQUEDA"
            single-line
            hide-details
        ></v-text-field>
        <!--busqueda-->
        <v-spacer></v-spacer>
        
        <v-tooltip bottom v-if="DatosdeUsuario.perfil != 3 && DatosdeUsuario.perfil !=4"> 
          <template v-slot:activator="{ on, attrs }">
            <v-checkbox
              v-bind="attrs"
              v-on="on"
              v-model="checkitems"
              @click="MostrarItems"
              color="primary"
              value="red"
              hide-details
            >
            <template v-slot:label>
              <div>
                Suspender
                  <v-icon>
                    mdi-magnify
                  </v-icon>
              </div>
              </template>
            </v-checkbox>
          </template>
          <span>Click para mostrar cuentas a suspender</span>
        </v-tooltip>

      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">

      <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          small
          @click="mostrarItem(item)"
          color="info"
        >
          mdi-eye
        </v-icon>
      </template>
      <span>Mostrar Item</span>
    </v-tooltip>

    <v-tooltip bottom v-if="item.chequeo == 0">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          small
          @click="Suspender(item)"
          color="error"
        >
          mdi-close-circle-outline
        </v-icon>
      </template>
      <span>Suspender</span>
    </v-tooltip>

    </template>

  </v-data-table>

  <!--Popup DELETE-->
        <v-dialog v-model="DialogSuspender" max-width="380px">
          <v-card>
             <v-card-title class="text-h5 grey lighten-2">
              Suspender
             </v-card-title>

              <v-card-text class="mt-0 mb-n5">
                <v-card-title>¿Desea suspender el ID # {{ItemSuspender.id}}?</v-card-title>
              </v-card-text>
              
              <v-divider></v-divider>
            
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" @click="DialogSuspender = false">Cerrar</v-btn>
              <v-btn color="primary" @click="SuspenderConfirm">Aceptar</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--Popup DELETE-->
  </div>
</template>

<script>
  import Nuevo from "./nuevo"
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'

  export default {
    components: {
        Nuevo,
    },

    props:['titulo','headers','arreglo'],

    created () {
      
    },

    data: () => ({
      checkitems: false,
      DialogSuspender: false,
      ItemSuspender: {id: 0},

      busqueda: '',

      Item: null,
      Accion: null,

      TablaVacia: null,
      items: [],
      
      NuevoActivo: false,
    }),

    watch:{
      arreglo(){
          if(!!this.arreglo){
            if(this.arreglo.lenght > 0){
              this.TablaVacia = true
            }else{
              this.TablaVacia = false
            }
          }
        },
    },

    methods: {
      ...mapActions(['ConsultarVentas','SuspenderCuentaStreaming']),

      mostrarItem (item) {
        this.Item = Object.assign({}, item)
        this.NuevoActivo = true
        this.Accion = 'Producto'
      },

      Suspender(item){
        this.ItemSuspender = Object.assign({}, item)
        this.DialogSuspender = true
      },

      SuspenderConfirm(){
        this.SuspenderCuentaStreaming(this.ItemSuspender)
        this.DialogSuspender = false
        this.ConsultarVentas()
      },

      MostrarItems(){
        if(this.checkitems){
          this.ConsultarVentas('1')
        }else{
          this.ConsultarVentas()
        }
      }

    },

    computed: {
      ...mapState([]),
      ...mapGetters(['DatosdeUsuario']),
    },
  }
</script>